export default __webpack_public_path__ + "static/media/VAS Client.bd7c7ace.jpg";